import { render, staticRenderFns } from "./settings-toolbar.vue?vue&type=template&id=7fbfdf4b&"
import script from "./settings-toolbar.vue?vue&type=script&lang=js&"
export * from "./settings-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports